import type { CommonData } from "../types/common";

// Pure availability check for the Tink section. Mirrors what `TinkAccountsRow`
// actually renders: applicant/co-applicant account arrays, falling back to the
// agent-submitted `psd2Data` for the applicant. Kept free of React/styled
// imports so it can be unit-tested without the UI toolkit.

// Accounts carried in the agent-submitted `psd2Data` JSON string, if any.
const parseAgentAccounts = (
  psd2DataString: string | undefined
): unknown[] | undefined => {
  if (!psd2DataString) {
    return undefined;
  }
  try {
    return (JSON.parse(psd2DataString) as { accounts?: unknown[] }).accounts;
  } catch {
    return undefined;
  }
};

// True only when there are Tink accounts to display for either applicant.
export const tinkHasData = (data: CommonData | undefined): boolean => {
  const tink = data?.integrations?.tink;
  const agentAccounts = parseAgentAccounts(
    data?.agentApiApplication?.applicant?.psd2Data
  );
  // Same resolution order as TinkAccountsRow: postscore data wins, else agent.
  const applicantAccounts = tink?.applicant?.accounts || agentAccounts || [];
  const coapplicantAccounts = tink?.coapplicant?.accounts || [];
  return applicantAccounts.length > 0 || coapplicantAccounts.length > 0;
};
